import React, { useState, Fragment } from "react";
import { ReactSVG } from "react-svg";
import { getAssets } from "@unisearch/helpers";
import styles from "./course_ranking_card_simple.module.scss";

const CourseRankingCardSimple = ({
  rankingType,
  rankingCompanyName,
  rankFrom,
  rankTo,
  rankingYear,
  rankVarying,
}) => {
  return (
    <div className={styles.course_ranking_card}>
      <div className={styles.ranking_heading}>
        <ReactSVG
          className={styles.trophy_icon}
          src={getAssets("assets/images/uni-profile/trophy-icon.svg")}
        />
        {rankFrom && (
          <div className={styles.rank_num}>
            {rankVarying}
            {rankFrom}
            {rankTo && rankTo > 0 ? " - " + rankTo : ""}
          </div>
        )}

        {rankingYear && (
          <div className={styles.rank_year}>in {rankingYear}</div>
        )}
      </div>
      <div className={styles.ranking_title}>
        {rankingType} <span>{rankingCompanyName}</span>
      </div>

      {/* <div className={`${styles.rank_list}`}>
        <span className={styles.num}>#20,</span>
        <span className={styles.text}>World University Ranking, 2020</span>
      </div>

      <div className={styles.rank_list}>
        <span className={styles.num}>#20,</span>
        <span className={styles.text}>World University Ranking, 2020</span>
      </div> */}
    </div>
  );
};

export default CourseRankingCardSimple;
